var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FlexBox, Text } from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';
import { useCallback, useMemo, useState } from 'react';
import TextMessage from '../TextMessage';
import { getAttachment, getAttachmentType } from '../utils/attachment';
import { StoryExpired } from './components/storyExpired';
import { StoryImage } from './components/storyImage';
import { StoryVideo } from './components/storyVideo';
import styles from './messageInstagram.module.scss';
export const MessageInstagram = (_a) => {
    var { conversationAttributes: { instagram_account_name, instagram_account_username, }, message, markup } = _a, otherProps = __rest(_a, ["conversationAttributes", "message", "markup"]);
    const [storyExpired, setStoryExpired] = useState(false);
    const handleStoryError = useCallback(() => {
        setStoryExpired(true);
    }, []);
    const storyAttachment = useMemo(() => {
        if (message.attached_files) {
            const attachment = message.attached_files instanceof Array
                ? message.attached_files[0]
                : message.attached_files;
            const type = getAttachmentType(attachment);
            if (type === 'image') {
                return (_jsx(StoryImage, { attachment: attachment, onError: handleStoryError }));
            }
            if (type === 'video') {
                return (_jsx(StoryVideo, { attachment: attachment, type: type, onError: handleStoryError }));
            }
        }
        return null;
    }, [handleStoryError, message]);
    const storyContent = useMemo(() => {
        return (_jsxs(FlexBox, Object.assign({ flexDirection: "column", margin: "300 0 0 0", borderWidth: "100", maxWidth: "400px", borderColor: colors.neutral['200'] }, { children: [_jsx(Box, Object.assign({ padding: "300" }, { children: _jsx(Text.Heading, Object.assign({ variant: "heading-4" }, { children: instagram_account_name })) })), _jsx(Box, Object.assign({ className: styles.storyAttachment }, { children: storyExpired ? _jsx(StoryExpired, {}) : storyAttachment }))] })));
    }, [instagram_account_name, storyAttachment, storyExpired]);
    const storyDescription = useMemo(() => {
        return (_jsx(Box, Object.assign({ margin: "0 0 0 200" }, { children: _jsx(Text.Paragraph, Object.assign({ variant: "4", subdued: true }, { children: message.text
                    ? 'commented on your story'
                    : `@${instagram_account_username} was mentioned in a story` })) })));
    }, [instagram_account_username, message.text]);
    return message.is_story ? (_jsx(TextMessage, Object.assign({}, otherProps, { message: message, content: storyContent, authorDescription: storyDescription, showMarkupAndContent: true }))) : (_jsx(TextMessage, Object.assign({}, otherProps, { message: message, content: getAttachment(message, { scaleImage: true }) })));
};
